export default "__VITE_ASSET__DTSGRnsG__"